<template>
  <div id="container">
    <img :src="require('../images/building.png')" alt="">
    <h2>Chức năng đang xây dựng!</h2>
  </div>
</template>

<script>

export default {
  name: 'Construction',
}
</script>

<style lang="scss" scoped>
#container {
  padding: 15vw;
  display: flex;
  align-items: center;
  flex-direction: column;

  h2 {
    margin-top: 8vh;
    font-size: 1.5em;
  }
}
</style>
